module.exports = __webpack_public_path__ + "img/1@2x(15).2913510f.png";